import React, { useMemo } from "react";
import { Chip, Tooltip } from "@mui/material";
import plus from "../../../../styles/svg/group-plus-icon.svg";
import minus from "../../../../styles/svg/group-minus-icon.svg";
import { useCustomSearchParams } from "../../../../hooks/useCustomSearchParams";
import { TooltipName } from "../../../../utils/Enums";

const CalculateCards = React.memo(({ cards, workflowSteps, isExpand }) => {
  const [isGeneric] = useCustomSearchParams("is_generic");

  const statusCards = (status) => {
    const filteredCards = cards.filter(card => card.generic_step_id * 1 === status);
    const remainingHours = filteredCards.reduce((accumulator, currentValue) => {
      const allocatedHours = currentValue.card.allocated_hours || 0;
      const totalHoursSpent = currentValue.total_hours_spent || 0;

      if (allocatedHours >= totalHoursSpent) {
        return accumulator + (allocatedHours - totalHoursSpent);
      }
      return accumulator;
    }, 0);

    return `${remainingHours} Hrs (${filteredCards.length})`;
  };

  return (
    <div className="d-flex align-items-center">
      {workflowSteps.map((step, idx) => (
        <p key={`grouping-status-chips-${idx}`} className="w-25 grouping-status-chips team-status-title">
          {statusCards(step.workflow_step_id)}
        </p>
      ))}
      <div className="w-25 d-flex justify-content-end-important">
        <Tooltip title={isExpand ? TooltipName.COLLAPSE : TooltipName.EXPAND}>
          <img src={isExpand ? minus : plus} alt="toggle-expand" />
        </Tooltip>
      </div>
    </div>
  );
});

export default CalculateCards;
